export enum AccountStatus {
  Active = 'ACTIVE',
  LiquidatingOnly = 'LIQUIDATING_ONLY',
  //****** UNCOMMENT BELOW WHEN 'RESTRICTED' OPTION HAS BEEN UPDATED ON THE BACKEND ********
  // Restricted = 'RESTRICTED',
}

export const AccountStatusDisplay: { [key in AccountStatus]: string } = {
  [AccountStatus.Active]: 'Unrestricted',
  [AccountStatus.LiquidatingOnly]: 'Liquidating Only',
  //****** UNCOMMENT BELOW WHEN 'RESTRICTED' OPTION HAS BEEN UPDATED ON THE BACKEND ********
  // [AccountStatus.Restricted]: 'Restricted',
}

export enum Platform {
  UnknownPlatform = 'UNKNOWN_PLATFORM',
  Mock = 'MOCK',
  Orbis = 'ORBIS',
}

export const PlatformDisplay: { [key in Platform]: string } = {
  [Platform.UnknownPlatform]: 'Third Party',
  [Platform.Mock]: 'Mock',
  [Platform.Orbis]: 'Orbis',
}

export interface RestrictionStatus {
  accountStatus: AccountStatus
  platform: Platform
}
